import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpAdapter, FeatureFlagsResponse } from '@portal-front/feature-flags/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class AngularHttpAdapter implements HttpAdapter {
  constructor(private http: HttpClient) {}

  async get(url: string): Promise<FeatureFlagsResponse> {
    const flags = await firstValueFrom(this.http.get<FeatureFlagsResponse>(url));
    return flags ?? {};
  }
}
